import { Link } from 'react-router-dom';
import { collections, comics } from '@/mocks/comics';

export default function CollectionSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">Collections</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-1 font-heading">
            <strong>精选合集</strong>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精心策划的漫画主题合集，一次看过瘾</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {collections.map((col) => {
            const collectionComics = col.comicIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean);
            return (
              <div key={col.id} className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-lg font-bold text-foreground-950 font-heading">{col.title}</h3>
                    <p className="text-sm text-foreground-500 mt-1">{col.description}</p>
                  </div>
                  <Link
                    to="/category/all"
                    className="flex-shrink-0 text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap mt-1"
                  >
                    查看全部 →
                  </Link>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  {collectionComics.map((comic) =>
                    comic ? (
                      <Link
                        key={comic.id}
                        to={`/comic/${comic.id}`}
                        className="group cursor-pointer"
                      >
                        <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2">
                          <img
                            src={comic.cover}
                            alt={`${comic.title} - ${col.title}`}
                            title={`${comic.title} - 韩国漫画${col.title}`}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                        <p className="text-xs font-semibold text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-1 text-center">
                          {comic.title}
                        </p>
                      </Link>
                    ) : null
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}